export default {
  API_ERROR: "Lo sentimos, algo salió mal. Por favor, inténtalo de nuevo.",
  FORM_ERROR: "Lo sentimos, pero necesitas escribir un poco más para compartir tus comentarios con nosotros."
}